export default {"src":"/_next/static/media/thunderstarright.8f528479.svg","height":164,"width":193,"blurWidth":0,"blurHeight":0};